import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 *
 * @deprecated use `import { cn } from '@/utils/cn';` instead
 * This function is deprecated to ensure consistency with the import statement
 *   used in AlignUI components, the UI library we are using.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
